



















































import { Component, Vue } from "vue-property-decorator";
import PreItem from './components/preItem.vue'
import clipboard from 'clipboard'
interface IDataSet {
  ele: string;
  title: string;
}
interface IAttributes {
  title: string;
  description: string;
  list: IAttributesDeatil[];
}
interface IOperaAttr {
  "justify-content": string;
  "flex-wrap": string;
  "flex-direction": string;
  "align-content": string;
  "align-items": string;
}
interface IAttributesDeatil {
  title: string;
  isDefault?: boolean;
  description: string;
}
@Component({
  components: {
    PreItem
  }
})

export default class App extends Vue {
  operaArray: IAttributes[] = [
    {
      title: "justify-content",
      description: "定义了项目在主轴上的对齐方式",
      list: [
        {
          title: "flex-start",
          isDefault: true,
          description: "默认值，左对齐"
        },
        {
          title: "flex-end",
          description: "右对齐"
        },
        {
          title: "center",
          description: "居中"
        },
        {
          title: "space-between",
          description: "两端对齐，项目之间的间隔都相等。"
        },
        {
          title: "space-around",
          description:
            "每个项目两侧的间隔相等。所以，项目之间的间隔比项目与边框的间隔大一倍。"
        }
      ]
    },
    {
      title: "align-items",
      description: "定义项目在交叉轴上如何对齐",
      list: [
        {
          title: "stretch",
          isDefault: true,
          description:
            "默认值，如果项目未设置高度或设为auto，将占满整个容器的高度。"
        },
        {
          title: "flex-start",
          description: "交叉轴的起点对齐。"
        },
        {
          title: "flex-end",
          description: "交叉轴的终点对齐。"
        },
        {
          title: "center",
          description: "交叉轴的中点对齐。"
        },
        {
          title: "baseline",
          description: "项目的第一行文字的基线对齐。"
        }
      ]
    },
    {
      title: "align-content",
      description: "项目只有一根轴线，该属性不起作用",
      list: [
        {
          title: "stretch",
          isDefault: true,
          description: "默认值，轴线占满整个交叉轴。"
        },
        {
          title: "flex-start",
          description: "与交叉轴的起点对齐。"
        },
        {
          title: "flex-end",
          description: "与交叉轴的终点对齐。"
        },
        {
          title: "center",
          description: "与交叉轴的中点对齐。"
        },
        {
          title: "space-between",
          description: "与交叉轴两端对齐，轴线之间的间隔平均分布。"
        },
        {
          title: "space-around",
          description:
            "每根轴线两侧的间隔都相等。所以，轴线之间的间隔比轴线与边框的间隔大一倍。"
        }
      ]
    },
    {
      title: "flex-direction",
      description: "主轴的方向（即项目的排列方向）",
      list: [
        {
          title: "row",
          isDefault: true,
          description: "默认值，主轴为水平方向，起点在左端。"
        },
        {
          title: "row-reverse",
          description: "主轴为水平方向，起点在右端。"
        },
        {
          title: "column",
          description: "主轴为垂直方向，起点在上沿。"
        },
        {
          title: "column-reverse",
          description: "主轴为垂直方向，起点在下沿。"
        }
      ]
    },
    {
      title: "flex-wrap",
      description: "如果一条轴线排不下，如何换行",
      list: [
        {
          title: "nowrap",
          isDefault: true,
          description: "默认，不换行。"
        },
        {
          title: "wrap",
          description: "换行，第一行在上方。"
        },
        {
          title: "wrap-reverse",
          description: "换行，第一行在下方。"
        }
      ]
    }
  ];
  operaAttr: IOperaAttr = {
    "justify-content": "flex-start",
    "flex-wrap": "nowrap",
    "flex-direction": "row",
    "align-content": "stretch",
    "align-items": "stretch"
  };
  previewItemCount: number = 4;
  get isChrome(): boolean {
    const userAgent = navigator.userAgent
    return userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1
  }
  get clipboardText(): string {
    return `display: flex;\nplace-content: ${this.operaAttr['align-content']} ${this.operaAttr['justify-content']};\nflex-flow: ${this.operaAttr['flex-direction']} ${this.operaAttr['flex-wrap']};\nalign-items: ${this.operaAttr['justify-content']};`
  }
  get isPC(): boolean {
    return !(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent))
  }
  get computedAttrText(): string {
    return '测试'
  }
  mounted(): void {
    const clip: any = new clipboard('.copy')
    clip.on('success', function (e) {
      e.clearSelection();
      alert('复制成功')
    })
  }
  operaClick(e: any): void {
    if (e.target.className.indexOf("radio") !== -1) {
      const dataset: IDataSet = e.target.dataset;
      this.$set(this.operaAttr, dataset.title, dataset.ele);
      if (dataset.title === 'flex-wrap' && dataset.ele === 'nowrap') {
        this.previewItemCount = 8
      }
    }
  }
  resetOperaAttr(): void {
    this.operaAttr = {
      "justify-content": "flex-start",
      "flex-wrap": "nowrap",
      "flex-direction": "row",
      "align-content": "stretch",
      "align-items": "stretch"
    };
  }
  itemCountOpera(isAdd: boolean): void {
    if (isAdd) {
      if (this.operaAttr['flex-wrap'] === 'nowrap') {
        if (this.previewItemCount >= 8) {
          alert('放不下了别加了')
        } else {
          this.previewItemCount++;
        }
      } else {
        this.previewItemCount++;
      }
    } else {
      if (this.previewItemCount >= 2) {
        this.previewItemCount--;
      }
    }
  }
}
